var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.52 6.94671L22.4 10.7067C22.6533 11.2267 23.3333 11.72 23.9067 11.8267L27.3067 12.3867C29.48 12.7467 29.9867 14.32 28.4267 15.8934L25.7733 18.5467C25.3333 18.9867 25.08 19.8534 25.2267 20.48L25.9867 23.76C26.5867 26.3467 25.2 27.36 22.92 26L19.7333 24.1067C19.16 23.76 18.2 23.76 17.6267 24.1067L14.44 26C12.16 27.3467 10.7733 26.3467 11.3733 23.76L12.1333 20.48C12.2533 19.84 12 18.9734 11.56 18.5334L8.90667 15.88C7.34667 14.32 7.85334 12.7467 10.0267 12.3734L13.4267 11.8134C14 11.72 14.68 11.2134 14.9333 10.6934L16.8133 6.93338C17.84 4.90671 19.4933 4.90671 20.52 6.94671Z",
    fill: "#17E1A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 7.66663H2.66669C2.12002 7.66663 1.66669 7.21329 1.66669 6.66663C1.66669 6.11996 2.12002 5.66663 2.66669 5.66663H10.6667C11.2134 5.66663 11.6667 6.11996 11.6667 6.66663C11.6667 7.21329 11.2134 7.66663 10.6667 7.66663Z",
    fill: "#17E1A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 26.3334H2.66669C2.12002 26.3334 1.66669 25.88 1.66669 25.3334C1.66669 24.7867 2.12002 24.3334 2.66669 24.3334H6.66669C7.21335 24.3334 7.66669 24.7867 7.66669 25.3334C7.66669 25.88 7.21335 26.3334 6.66669 26.3334Z",
    fill: "#17E1A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00002 17H2.66669C2.12002 17 1.66669 16.5467 1.66669 16C1.66669 15.4533 2.12002 15 2.66669 15H4.00002C4.54669 15 5.00002 15.4533 5.00002 16C5.00002 16.5467 4.54669 17 4.00002 17Z",
    fill: "#17E1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1dfcb365598eb0ad87e81b49564b60aa.svg";
export { ForwardRef as ReactComponent };